import {
  useAuthContextDispatch,
  useAuthContextState,
} from "@AuthContext/store";
import CustomCard from "@Components/CCard/CustomCard";
import ViewFileInfo from "@Components/CFilesInfo/ViewFileInfo";
import CreateFormItem from "@Components/form/CreateFormItem/_RenderFormItem";
import type { ITypeQuestionProp } from "@Interface/patient";
import { VisitField, VisitFiles } from "@Interface/visit";
import _VisitService, { visitResultDetection } from "@Services/api/visit";
import { _RES_validateError } from "@Utils/validate";
import useZipDownload2 from "@Views/Diagnostics/FormDiagnostics/fileDownload";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import type { FormInstance } from "antd";
import { Button, Col, Row, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import AbusAiReport from "./AbusAiReport";
import { IResultReport3D } from "./ModalReport3D";

interface Props {
  dataForm?: FormInstance<any> | any;
  questionsForm?: ITypeQuestionProp | null;
  fileList?: VisitFiles[];
  studyId?: string | null;
  visitInfo?: VisitField | null;
  reportFileList?: VisitFiles[];
}

const ABUS = ({ questionsForm, dataForm, fileList, visitInfo }: Props) => {
  const { token } = useAuthContextState();
  const { _signOut } = useAuthContextDispatch();
  const params = useParams() as { visitId: string };
  const [downloadAndZip] = useZipDownload2();
  const [visibleViewReport, setVisibleViewReport] = useState(false);

  const [report3D, setReport3D] = useState<IResultReport3D[]>([]);

  const handleDownload = async () => {
    const id = Number(params.visitId);
    const res = await _VisitService.visitDownloadFiles(
      id,
      token.accessToken,
      "A_BUS"
    );
    const data = res.result;
    downloadAndZip(
      data,
      `${visitInfo?.patient?.fullName?.replace(/ /g, "-")}-A_BUS`
    );
  };

  const onOk = () => {
    // setVisibleViewReport(false)
  };
  const onCancel = () => {
    setVisibleViewReport(false);
  };

  useEffect(() => {
    initialData();
  }, []);

  const initialData = async () => {
    const keyOnLoad = "getVisitResultDetection";
    const res = await visitResultDetection(params.visitId, token.accessToken);
    _RES_validateError(res, keyOnLoad, {
      Code_401: { runOption: _signOut },
      Code_200: {
        runOption: () => {
          setReport3D(res?.result);
          // console.log("res", res);
          return true;
        },
      },
    });
  };

  const geStatus = (status: string) => {
    switch (status) {
      case "รอประมวลผล AI":
        return { status: "processing", name: "รอประมวลผล AI" };
      case "ยังไม่ประมวลผล AI":
        return { status: "warning", name: "ยังไม่ประมวลผล AI" };
      case "ประมวลผล AI เสร็จสิ้น":
        return { status: "success", name: "ประมวณผล AI เสร็จสิ้น" };
      default:
        return { status: "warning", name: "ยังไม่ประมวลผล AI" };
    }
  };

  return (
    <Row className="container-box tabs-content" gutter={[10, 10]}>
      <Col span={24}>
        <ViewFileInfo
          title="ข้อมูลภาพ ABUS"
          extraAction={[
            <Button
              icon={<VerticalAlignBottomOutlined />}
              size="middle"
              onClick={handleDownload}
              disabled={false}
            />,
          ]}
          status={[geStatus(visitInfo?.statusAi || "")]}
          fileList={fileList || []}
        />
      </Col>
      <Col span={24}>
        <CustomCard title="ABUS Form">
          <Tabs type="card" size="middle" style={{ background: "#fff" }}>
            {!!questionsForm?.abus &&
              questionsForm?.abus?.map((item: any, ind: number) => (
                <Tabs.TabPane
                  tab={
                    <span style={{ textTransform: "capitalize" }}>
                      {item.name}
                    </span>
                  }
                  key={item.name}
                  style={{ background: "#fff" }}
                >
                  <div className="box">
                    {item.name === "AI" ? (
                      <AbusAiReport values={report3D} />
                    ) : (
                      <CreateFormItem
                        key={ind}
                        values={item.questions.map((item: any) => {
                          if (item.type === "imageMarker") {
                            return {
                              ...item,
                              keyName: "markers",
                              imageMarkerOption: {
                                src: item.imageMarkerOption?.src,
                                type: "abus",
                              },
                            };
                          }
                          return item;
                        })}
                        form={dataForm}
                        visitInfo={visitInfo}
                        fileList={fileList}
                      />
                    )}
                  </div>
                </Tabs.TabPane>
              ))}
          </Tabs>
        </CustomCard>
      </Col>
    </Row>
  );
};

export default ABUS;
